import type { ReactNode } from "react";

type PageHeaderProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
  leading?: ReactNode;
};

export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  breadcrumb,
  leading,
}: PageHeaderProps) {
  const showTopRow = Boolean(leading || breadcrumb);
  return (
    <header className="flex flex-wrap items-center justify-between gap-4">
      <div>
        {showTopRow ? (
          <div className="mb-3 flex items-center gap-3">
            {leading ? <div className="flex items-center">{leading}</div> : null}
            {breadcrumb}
          </div>
        ) : null}
        {eyebrow ? (
          <p className="text-sm uppercase tracking-[0.2em] text-muted-foreground/70">
            {eyebrow}
          </p>
        ) : null}
        <h1 className="text-3xl font-semibold">{title}</h1>
        {description ? (
          <p className="mt-2 text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-3">{actions}</div> : null}
    </header>
  );
}
